import ThisModule from "./Table";

export default ThisModule;
